import React from 'react';
import { Search } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { Input } from "components/UI/Input";


const SearchComponent = ({value, setvalue}) => {
    const { t } = useTranslation();
    return (
        <div className="relative max-w-md">
            <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
            <Input
                className="pl-10"
                placeholder={t("searchHere")}
                value={value}
                onChange={(e) => setvalue(e.target.value)}
            />
        </div>
    );
}
export default SearchComponent;